import { render, staticRenderFns } from "./ScreenSlider.vue?vue&type=template&id=54c29b89&"
import script from "./ScreenSlider.vue?vue&type=script&setup=true&lang=js&"
export * from "./ScreenSlider.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ScreenSlider.vue?vue&type=style&index=0&id=54c29b89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports